var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"visible !important"},attrs:{"id":"main-wrapper"}},[_c('vue-snotify'),_c('Header',{attrs:{"username":_vm.username}}),_c('Sidebar',{attrs:{"username":_vm.username}}),_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }